<div
    class="tw-flex sm:tw-flex md:tw-hidden tw-flex-col tw-m-5"
    *ngIf="imageObjectFA.length || imageObjectAW.length || imageObjectANM.length || imageObjectNS.length"
>
    <div class="tw-text-[24px] tw-font-semibold tw-leading-[32px] tw-text-[#003A70] tw-mb-4">
        {{ "CGC_DEV_PROG_PAGE.GALLERY" | translate }}
    </div>
    <div
        class="tw-flex tw-items-center tw-gap-4 tw-ring-1 tw-ring-inset tw-ring-gray-300 tw-rounded-2xl tw-bg-white tw-mb-5"
    >
        <div class="filter-container tw-flex-1">
            <button
                class="tw-h-[56px] tw-p-[18px] tw-font-bold tw-flex tw-items-center tw-justify-between tw-gap-3 tw-w-full tw-flex-1"
                [matMenuTriggerFor]="menu"
            >
                {{ initialSelectedValue | translate }}
                <mat-icon fontIcon="keyboard_arrow_down" class="tw-text-[22px]" />
            </button>
            <mat-menu #menu="matMenu">
                <button
                    mat-menu-item
                    class="tw-w-[400px]"
                    (click)="selectedSegment(SEGMENT_FA)"
                    *ngIf="imageObjectFA.length"
                >
                    {{ FINANCIAL_ADVISORY | translate }}
                </button>
                <button
                    mat-menu-item
                    class="tw-w-[400px]"
                    (click)="selectedSegment(SEGMENT_AWP)"
                    *ngIf="imageObjectAW.length"
                >
                    {{ ADVISORY_WORKSHOP | translate }}
                </button>
                <button
                    mat-menu-item
                    class="tw-w-[400px]"
                    (click)="selectedSegment(SEGMENT_ANM)"
                    *ngIf="imageObjectANM.length"
                >
                    {{ ACCESS_NEW_MARKETS | translate }}
                </button>
                <button
                    mat-menu-item
                    class="tw-w-[400px]"
                    (click)="selectedSegment(SEGMENT_NS)"
                    *ngIf="imageObjectNS.length"
                >
                    {{ NETWORKING_SESSION | translate }}
                </button>
            </mat-menu>
        </div>
    </div>
    <div
        class="tw-flex tw-items-center tw-gap-4 tw-ring-1 tw-ring-inset tw-ring-gray-300 tw-rounded-2xl tw-bg-white"
    >
        <p-carousel
            *ngIf="initialSelectedValue == FINANCIAL_ADVISORY && imageObjectFA.length"
            [value]="imageObjectFA" 
            [numVisible]="3" 
            [numScroll]="1" 
            autoplayInterval="3000"
            [circular]="true" 
            [responsiveOptions]="responsiveOptions"
        >
            <ng-template let-product pTemplate="item">
                <img 
                    src="{{product.image}}" 
                    [alt]="product.alt" 
                    class="tw-w-[205px] tw-h-[205px] tw-m-auto"
                />
            </ng-template>
        </p-carousel>
        <p-carousel
            *ngIf="initialSelectedValue == ADVISORY_WORKSHOP && imageObjectAW.length"
            [value]="imageObjectAW" 
            [numVisible]="3" 
            [numScroll]="1" 
            autoplayInterval="3000"
            [circular]="true" 
            [responsiveOptions]="responsiveOptions"
        >
            <ng-template let-product pTemplate="item">
                <img 
                    src="{{product.image}}" 
                    [alt]="product.alt" 
                    class="tw-w-[205px] tw-h-[205px] tw-m-auto"
                />
            </ng-template>
        </p-carousel>
        <p-carousel
            *ngIf="initialSelectedValue == ACCESS_NEW_MARKETS && imageObjectANM.length"
            [value]="imageObjectANM" 
            [numVisible]="3" 
            [numScroll]="1" 
            autoplayInterval="3000"
            [circular]="true" 
            [responsiveOptions]="responsiveOptions"
        >
            <ng-template let-product pTemplate="item">
                <img 
                    src="{{product.image}}" 
                    [alt]="product.alt" 
                    class="tw-w-[205px] tw-h-[205px] tw-m-auto"
                />
            </ng-template>
        </p-carousel>
        <p-carousel
            *ngIf="initialSelectedValue == NETWORKING_SESSION && imageObjectNS.length"
            [value]="imageObjectNS" 
            [numVisible]="3" 
            [numScroll]="1" 
            autoplayInterval="3000"
            [circular]="true" 
            [responsiveOptions]="responsiveOptions"
        >
            <ng-template let-product pTemplate="item">
                <img 
                    src="{{product.image}}" 
                    [alt]="product.alt" 
                    class="tw-w-[205px] tw-h-[205px] tw-m-auto"
                />
            </ng-template>
        </p-carousel>
    </div>
</div>